import React from "react";

export function GreeceTermsGreekBody() {
  return (
    <>
      <h1>ΓΕΝΙΚΟΙ ΟΡΟΙ ΚΑΙ ΠΡΟΫΠΟΘΕΣΕΙΣ</h1>

      <p className="fs-4">
        <strong>Ημερομηνία τελευταίας τροποποίησης:</strong>
      </p>

      <h1>1. ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ</h1>
      <p className="fs-4">
        Η Smart Mobile Tech – FZCO (εφεξής καλούμενη η «Εταιρεία»), εδρεύει στην
        DSO-THUB-G-D-FLEX-G003E , building THUB, Dubai Silicon Oasis , Dubai, με
        αριθμό VAT 100606110300003, η οποία είναι καταχωρημένη στο οικείο
        Εμπορικό Επιμελητήριο με αριθμό DSO-FZCO- 2420 με
        site: https://www.mobileartsme.com/ και email:
        carrierbilling@mobileartsme.com, bdev@mobileartsme.com.
      </p>
      <p className="fs-4">
        Απαραίτητη προϋπόθεση χρήσης της Υπηρεσίας AI Avatar (εφεξής καλούμενη η
        «Υπηρεσία») είναι να είστε άνω των 18 ετών, καθώς και να σας έχει δοθεί
        η άδεια του ατόμου που πληρώνει τον λογαριασμό κινητής τηλεφωνίας.
      </p>
      <p className="fs-4">
        Οι Υπηρεσίες που παρέχονται από την Εταιρεία στους αποδέκτες τους καθώς
        και η χρήση αυτών διέπονται από τους παρόντες Όρους και Προϋποθέσεις.
        Επισημαίνεται ότι τυχόν αναρτημένοι Όροι και Προϋποθέσεις στην επίσημη
        ιστοσελίδα της Εταιρείας https://www.mobileartsme.com/ ενσωματώνονται
        στους παρόντες Όρους και Προϋποθέσεις, με τους οποίους συνδέονται κατά
        απόλυτο και ισοδύναμο τρόπο, αποτελώντας ενιαίο κείμενο (εφεξής
        καλούμενοι συνολικά οι «Όροι»).
      </p>
      <p className="fs-4">
        Το περιεχόμενο των παρόντων Όρων αποτελεί την πλήρη συμφωνία μεταξύ της
        Εταιρείας και των αποδεκτών των Υπηρεσιών (εφεξής χάριν συντομίας ο
        «Πελάτης» ή «Τελικός Χρήστης»). Ο Τελικός Χρήστης με την χρήση των
        υπηρεσιών της Εταιρείας αποδέχεται ρητά και ανεπιφύλακτα την συμμόρφωση
        του με τους Όρους.
      </p>

      <h1>2. ΔΥΝΑΤΟΤΗΤΑ ΤΡΟΠΟΠΟΙΗΣΗΣ ΤΩΝ ΟΡΩΝ</h1>
      <p className="fs-4">
        Η Εταιρεία έχει το δικαίωμα να τροποποιεί τους Όρους οποτεδήποτε και
        άνευ προηγούμενης προειδοποιήσεως του «Πελάτη». Η οποιαδήποτε
        τροποποίηση των όρων αναπτύσσει άμεσα ισχύ έναντι όλων των «Πελατών» με
        την ανάρτηση του κειμένου των τροποποιημένων Όρων στην επίσημη
        ιστοσελίδα της Εταιρείας. Τέτοιες τροποποιήσεις καθίστανται αναγκαίες,
        ενδεικτικώς, σε περιπτώσεις μεταβολών του νομοθετικού πλαισίου οπότε
        υπάρχει ανάγκη εναρμόνισης τους ή αλλαγές στις παρεχόμενες Υπηρεσίες. Ως
        εκ τούτου ο Πελάτης οφείλει να επισκέπτεται τακτικά την ιστοσελίδα της
        Εταιρείας προκειμένου να λαμβάνει έγκαιρη γνώση τυχόν τροποποιήσεων.
      </p>
      <p className="fs-4">
        Σε περίπτωση διαφωνίας του Τελικού Χρήστη με το κείμενο των
        τροποποιημένων όρων υποχρεούται να διακόψει άμεσα την χρήση των
        Υπηρεσιών, άλλως η Εταιρεία ουδεμία ευθύνη φέρει.
      </p>

      <h1>3. ΕΙΔΟΣ ΚΑΙ ΠΕΡΙΕΧΟΜΕΝΟ ΥΠΗΡΕΣΙΩΝ</h1>
      <p className="fs-4">
        Το είδος των παρεχόμενων Υπηρεσιών από την Εταιρεία στους Τελικούς
        Χρήστες αφορά ψηφιακές και άλλες συναφούς περιεχομένου υπηρεσίες, όπως
        ενδεικτικά αναφέρονται γραπτά μηνύματα, παιχνίδια, διαγωνισμούς, αρχεία
        ήχου ή/και εικόνας (εφεξής καλούμενες «Υπηρεσίες Περιεχομένου»).
      </p>
      <p className="fs-4">
        Οι Υπηρεσίες Περιεχομένου παρέχονται από την Εταιρεία διαδικτυακά, μέσω
        του εκάστοτε παρόχου υπηρεσιών κινητής τηλεφωνίας του Τελικού Χρήστη
        (εφεξής καλούμενος ο «Πάροχος») με την μορφή Short Message Services
        (SMS), General Packet Radio Services (GPRS), Third Generation Services
        (3G) ή οποιοδήποτε άλλο συναφή τρόπο.
      </p>
      <p className="fs-4">
        Στα πλαίσια διαρκούς αναζήτησης τρόπων βελτίωσης της εμπειρίας των
        Τελικών Χρηστών κατά την χρήση των Υπηρεσιών της Εταιρείας, η τελευταία
        μπορεί να προσθέτει ή να αφαιρεί λειτουργίες και χαρακτηριστικά, να
        αναστέλλει ή ακόμα και να διακόπτει κάποια Υπηρεσία της.
      </p>
      <p className="fs-4">
        Η «Υπηρεσία» παρέχεται στους Τελικούς Χρήστες στην Ελλάδα μέσω της τεχνικής υποδομής και των 5ψηφίων αριθμοδοτικών πόρων-κωδικών της εταιρείας Mobilly Μονοπρόσωπη ΙΚΕ, με έδρα: Τζαφέρη 16, ΤΚ 11854 Γκάζι-Αθήνα, Ελλάδα, Τηλέφωνο Εξυπηρέτησης Πελατών: 2104445975, support@psmsgreece.gr
      </p>
      <p className="fs-4">
        Με την αποδοχή των παρόντων Όρων και Προϋποθέσεων, συγκατατίθεστε ρητά
        στην εγγραφή στην υπηρεσία, στην δημιουργία λογαριασμού και στην παροχή
        της υπηρεσίας ψηφιακού περιεχομένου καθώς επίσης, επιβεβαιώνετε και
        αναγνωρίζετε ότι με την αποδοχή αυτή παραιτείστε ρητά από το δικαίωμα
        υπαναχώρησης εντός 14 ημερών από την εγγραφή και την αγορά της ψηφιακής
        υπηρεσίας.
      </p>

      <h1>4. ΧΡΕΩΣΕΙΣ</h1>
      <p className="fs-4">
        Οι χρεώσεις δύνανται να διαφοροποιούνται ανάλογα με τις παρεχόμενες
        Υπηρεσίες και συγκεκριμένα i) συνδρομή σε Υπηρεσίες Περιεχομένου, ii)
        δωρεάν μονάδες σε λήψη αρχείων («Υπηρεσία Club») και iii) μεμονωμένες
        παραγγελίες.
      </p>
      <p className="fs-4">
        Η τιμολόγηση των χρεώσεων των παρεχόμενων Υπηρεσιών διαφοροποιείται ως
        εξής: i) για σταθερές συνδρομές πραγματοποιείται μέσω του λογαριασμού
        κινητής τηλεφωνίας του Παρόχου του Πελάτη και ii) για προπληρωμένες
        συνδρομές οι χρεώσεις αφαιρούνται από το πιστωτικό υπόλοιπο του Πελάτη.
      </p>
      <p className="fs-4">
        Με την χρήση των Υπηρεσιών της Εταιρείας, ο Πελάτης αποδέχεται πλήρως
        τις χρεώσεις της Εταιρείας, όπως αναφέρονται κάθε φορά στην ιστοσελίδα
        της Εταιρείας ενώ υποχρεούται να τις καταβάλλει εξ ολοκλήρου.
      </p>
      <p className="fs-4">
        Η χρέωση του Πελάτη για όλα τα γραπτά μηνύματα που του αποστέλλονται θα
        πραγματοποιείται μέσω του Παρόχου του και σύμφωνα με τις τυπικές
        χρεώσεις, όπως διαφοροποιούνται ανά Πάροχο.
      </p>
      <p className="fs-4">
        Τα γραπτά μηνύματα που αποστέλλονται στον Τελικό Χρήστη μέσω του πενταψήφιου κωδικού 54632 (CALL2ACTION, μήνυμα καλωσορίσματος, μηνιαία ενημέρωση, δεκαπενθήμερη ενημέρωση, επιβεβαίωση διαγραφής) είναι δωρεάν.
      </p>
      <p className="fs-4">
        H χρέωση της συνδρομητικής υπηρεσίας ανέρχεται σε 2,29 € ανά SMS (έως 12
        SMS τον μήνα) (συμπεριλαμβανομένου ΦΠΑ και τελών κινητής), που θα
        λαμβάνεται από τον 5ψήφιο κωδικό 54088 ή 54933 ή σε 0,57 € ανά SMS (έως 48
        SMS τον μήνα) (συμπεριλαμβανομένου ΦΠΑ και τελών κινητής), που θα
        λαμβάνεται από τον 5ψήφιο κωδικό 54444 ή 54002.{" "}
        <a
          href="https://site.mobilly.gr/"
          target="_blank"
          rel="noopener noreferrer"
          className="faq-inline-link"
        >
          Τελική Τιμή Μηνύματος
        </a>
      </p>
      <p className="fs-4">
        Περαιτέρω η Εταιρεία διατηρεί το δικαίωμα να προβαίνει μονομερώς σε
        τροποποίηση των χρεώσεων. Οι τροποποιημένες χρεώσεις τίθενται σε ισχύ
        μετά την ανάρτηση τους στην ιστοσελίδα https://www.mobileartsme.com/ της
        Εταιρείας. Οι ήδη υπάρχοντες Πελάτες της Εταιρείας θα ενημερώνονται για
        τις τροποποιήσεις μέσω γραπτού μηνύματος μία εβδομάδα πριν την
        τροποποίηση. Οι τροποποιημένες χρεώσεις θα αναπτύσσουν ισχύ για τους
        νέους Πελάτες, καθώς και για Πελάτες, οι οποίοι είναι ήδη εγγεγραμμένοι
        την στιγμή της τροποποίησης, εφόσον εξακολουθούν να κάνουν χρήση των
        Υπηρεσιών μετά την ενημέρωση τους για την τροποποίηση των χρεώσεων.
      </p>
      <p className="fs-4">
        Στα πλαίσια παροχής των Υπηρεσιών της, η Εταιρεία προβαίνει σε καταγραφή
        του αριθμού κινητού τηλεφώνου του Τελικού Χρήστη στο ηλεκτρονικό της
        σύστημα. Με την χρήση των Υπηρεσιών, ο Τελικός Χρήστης συναινεί στην εν
        λόγω καταγραφή και την αποδέχεται ως απαραίτητη για την παροχή των
        Υπηρεσιών της Εταιρείας σε αυτόν.
      </p>

      <h1>5. ΔΙΚΑΙΩΜΑΤΑ ΤΕΛΙΚΟΥ ΧΡΗΣΤΗ</h1>
      <p className="fs-4">
        Με την χρήση των Υπηρεσιών, η Εταιρεία χορηγεί στον Τελικό Χρήστη την
        άδεια λήψης, αποθήκευσης και να προβολής των Υπηρεσιών Περιεχομένου.
        Μοναδικός σκοπός της χορηγήσεως της εν λόγω άδεια είναι η διευκόλυνση
        του Τελικού Χρήστη κατά την χρήση και απόλαυση των προνομίων των
        Υπηρεσιών, όπως παρέχονται από την Εταιρεία και σύμφωνα με τους Όρους.
        Για τον λόγο αυτό, η συγκεκριμένη άδεια είναι προσωποπαγής, μη
        αποκλειστική και δεν δύναται να εκχωρηθεί.
      </p>
      <p className="fs-4">
        Ο Τελικός Χρήστης μπορεί να λαμβάνει ανακοινώσεις υπηρεσιών,
        διαχειριστικά μηνύματα και άλλες πληροφορίες κατά την χρήση των
        Υπηρεσιών. Σε κάθε περίπτωση, ο Τελικός Χρήστης έχει δικαίωμα να ζητήσει
        την εξαίρεση του από αυτές τις επικοινωνίες.
      </p>

      <h1>6. ΥΠΟΧΡΕΩΣΕΙΣ ΤΟΥ ΤΕΛΙΚΟΥ ΧΡΗΣΤΗ</h1>
      <p className="fs-4">
        Θεμελιώδη υποχρέωση του Τελικού Χρήστη αποτελεί η συμμόρφωση του με τις
        πολιτικές της Εταιρείας αναφορικά με τις Υπηρεσίες. Επίσης, ο Τελικός
        Χρήστης οφείλει να χρησιμοποιεί τις Υπηρεσίες κατά τρόπο σύμφωνο με την
        εθνική νομοθεσία.
      </p>
      <p className="fs-4">
        Συγκεκριμένα, ο Τελικός Χρήστης οφείλει να απέχει από οποιαδήποτε κακή
        χρήση των Υπηρεσιών, όπως τέτοια αποτελεί ενδεικτικά, η πρόσβασης σε
        αυτές κατά τρόπο αντικείμενο προς τις πολιτικές, όρους και οδηγίες της
        Εταιρείας.
      </p>
      <p className="fs-4">
        Σε κάθε περίπτωση, δεν παρέχεται στον Τελικό Χρήστη η άδεια να
        αντιγράφει, αναπαράγει, τροποποιεί, να δημιουργεί παράγωγα έργα (όπως
        αυτά που προκύπτουν από μεταφράσεις, προσαρμογές ή άλλες αλλαγές), να
        επικοινωνεί, να δημοσιεύει, να εκτελεί δημόσια, μεταβιβάζει, πωλεί,
        μισθώνει, διανέμει και, γενικά, να εμπορεύεται, ή να χρησιμοποιεί με
        οποιονδήποτε άλλο μη εξουσιοδοτημένο τρόπο τις Υπηρεσίες Περιεχομένου ή
        μέρος αυτών, εκτός εάν η Εταιρεία ρητώς συναινεί σε αυτή τη χρήση.
      </p>

      <h1>7. ΕΥΘΥΝΗ-ΕΓΓΥΗΣΕΙΣ ΚΑΙ ΔΗΛΩΣΕΙΣ ΑΠΟΠΟΙΗΣΗΣ</h1>
      <p className="fs-4">
        Ουδεμία ευθύνη της Εταιρείας στοιχειοθετείται σε περίπτωση ενδεχόμενης
        ζημίας του Τελικού Χρήστη σε σχέση με τις Υπηρεσίες. Σε κάθε περίπτωση,
        αν προκύψει απαίτηση του Τελικού Χρήστη κατά της Εταιρείας σχετικά με
        τους Όρους, συμπεριλαμβανομένων και τυχόν σιωπηρών εγγυήσεων, η συνολική
        ευθύνη της Εταιρείας περιορίζεται ρητά στο ποσό που κατέβαλε ο Τελικός
        Χρήστης για την παροχή των Υπηρεσιών.
      </p>
      <p className="fs-4">
        Σε περίπτωση διακοπής της χρήσης των Υπηρεσιών, ο Τελικός Χρήστης δεν
        έχει δικαίωμα να αξιώσει μείωση των χρεώσεων ή επιστροφή χρημάτων για
        χρεώσεις που έχουν ήδη καταβληθεί.
      </p>
      <p className="fs-4">
        Κατά την παροχή των Υπηρεσιών της, η Εταιρεία καταβάλλει ένα εύλογο
        επίπεδο δεξιότητας και προσοχής στα πλαίσια της κοινής εμπορικής
        πρακτικής και συναλλαγής. Εντούτοις, η Εταιρεία δεν δύναται να προβεί σε
        συγκεκριμένες εγγυήσεις για τις Υπηρεσίες, όπως για τις συγκεκριμένες
        λειτουργίες των Υπηρεσιών ή την αξιοπιστία ή την διαθεσιμότητα ή την
        δυνατότητα τους να ικανοποιήσουν ή όχι τις ανάγκες του Τελικού Χρήστη.
        Συνεπώς, οι Υπηρεσίες της Εταιρείας παρέχονται στο Τελικό Χρήστη «ως
        έχουν».
      </p>
      <p className="fs-4">
        Η ενδεχόμενη διακοπή ή δυσχερής πρόσβαση του Τελικού Χρήστη στις
        Υπηρεσίες ένεκα παραγόντων, οι οποίοι δεν δύνανται να προβλεφθούν και να
        αποφευχθούν από την Εταιρεία στα πλαίσια του ευλόγως αναμενόμενου
        ελέγχου που ασκεί (για παράδειγμα τεχνικά προβλήματα στο δίκτυο του
        Παρόχου), είναι δυνατή οποτεδήποτε. Στην ανωτέρω περίπτωση η Εταιρεία
        αποποιείται ρητά της οποιαδήποτε ευθύνης.
      </p>

      <h1>8. ΑΠΟΖΗΜΙΩΣΗ</h1>
      <p className="fs-4">
        Ο Τελικός Χρήστης δεσμεύεται να μην προκαλέσει βλάβη της Εταιρείας κατά
        την Χρήση των Υπηρεσιών, σεβόμενους τους Όρους Χρήσης και Προϋποθέσεις
        παροχής αυτών. Σε περίπτωση πρόκλησης τέτοιας βλάβης ή παραβίασης των
        Όρων και Προϋποθέσεων χρήσης των Υπηρεσιών, ο Τελικός Χρήστης
        υποχρεούται να αποζημιώσει την Εταιρεία και τους εκπροσώπους,
        εργαζόμενους και συνεργάτες της, για οποιαδήποτε απαίτηση, αγώγιμη
        αξίωση και διαδικασία ενώπιον οποιασδήποτε δικαστικής ή διοικητικής ή
        άλλης αρμόδιας Αρχής και η οποία σχετίζεται με την χρήση των Υπηρεσιών ή
        με παράβαση των Όρων. Στις εν λόγω ενδεχόμενες απαιτήσεις της Εταιρείας
        συμπεριλαμβάνονται, ενδεικτικά οποιαδήποτε υποχρέωση αποζημίωσης ή
        δαπάνη, η οποία πηγάζει από απαιτήσεις, βλάβες, ζημίες, δικαστικά έξοδα
        και δικηγορικές αμοιβές.
      </p>

      <h1>9. ΚΑΤΑΓΓΕΛΙΑ</h1>
      <p className="fs-4">
        Η Εταιρεία έχει το δικαίωμα να καταγγείλει άμεσα ή να περιορίσει την
        πρόσβαση του Τελικού Χρήστη στις Υπηρεσίες, με ή χωρίς προηγούμενη
        ειδοποίηση, για τους κάτωθι λόγους: (α) λόγω παραβίασης των παρόντων
        Όρων, (β) κατόπιν σχετικού αιτήματος των δικαστικών ή άλλων αρμόδιων
        κρατικών αρχών, (γ) λόγω διακοπής ή ουσιώδους τροποποίησης των Υπηρεσιών
        (ή μέρους αυτών), (δ) λόγω απρόβλεπτων τεχνικών θεμάτων ή προβλημάτων ή
        θεμάτων ασφαλείας, (ε) εξαιτίας απατηλών ή παράνομων δραστηριοτήτων του
        Τελικού Χρήστη, (στ) λόγω μη καταβολής ή καθυστερήσεων καταβολής των
        Χρεώσεων που οφείλονται από τον Τελικό Χρήστη σε σχέση με τις
        παρεχόμενες Υπηρεσίες, (ζ) κατόπιν σχετικού αιτήματος του Παρόχου του
        Τελικού Χρήστη.
      </p>
      <p className="fs-4">
        Μετά την καταγγελία εκ μέρους της Εταιρείας, ο Τελικός Χρήστης δεν θα
        έχει πρόσβαση τις Υπηρεσίες, ανεξάρτητα εάν έχει καταβάλει τις σχετικές
        Χρεώσεις για την χρήση αυτών, μη δυνάμενος να ζητήσει από την Εταιρεία
        την επιστροφή των χρημάτων που είχε ήδη καταβάλλει.
      </p>
      <p className="fs-4">
        Η ανωτέρω καταγγελία ή ο περιορισμός της πρόσβασης θα πραγματοποιείται
        κατά την απόλυτη διακριτική ευχέρεια της Εταιρείας ενώ η τελευταία
        ουδεμία ευθύνη φέρει έναντι του Τελικού Χρήστη ή οποιουδήποτε τρίτου σε
        τέτοια περίπτωση.
      </p>
      <p className="fs-4">
        Ο Τελικός Χρήστης δύναται να ζητήσει οποτεδήποτε την διακοπή της χρήσης
        των Υπηρεσιών.
      </p>

      <h1>10. ΠΝΕΥΜΑΤΙΚΗ ΙΔΙΟΚΤΗΣΙΑ</h1>
      <p className="fs-4">
        Στον όρο δικαιώματα Πνευματικής Ιδιοκτησίας περιλαμβάνονται ενδεικτικά
        και όχι περιοριστικά, τα εμπορικά σήματα, εμπορικές επωνυμίες,
        δικαιώματα πνευματικής ιδιοκτησίας, δικαιώματα βάσης δεδομένων,
        κατοχυρωμένα σχέδια, διπλώματα ευρεσιτεχνίας, και οποιοδήποτε άλλα
        παρόμοια δικαιώματα.
      </p>
      <p className="fs-4">
        Τα δικαιώματα Πνευματικής Ιδιοκτησίας προστατεύονται σε οποιαδήποτε χώρα
        ενώ εκκρεμείς αιτήσεις κατοχύρωσης, που σχετίζονται με τις Υπηρεσίες της
        Εταιρείας ή/και την ιστοσελίδα της παραμένουν πάντοτε στην κυριότητα της
        Εταιρείας.
      </p>

      <h1>11. ΕΚΧΩΡΗΣΗ</h1>
      <p className="fs-4">
        Δεν επιτρέπεται η εκχώρηση ή μεταβίβαση οποιουδήποτε από τα δικαιώματα ή
        τις υποχρεώσεις του Τελικού Χρήστη.
      </p>
      <p className="fs-4">
        Η Εταιρεία έχει το δικαίωμα κατά την διακριτική της ευχέρεια να
        εκχωρήσει εν όλω ή εν μέρει, τα δικαιώματα ή τις υποχρεώσεις της που
        πηγάζουν από τους Όρους και Προϋποθέσεις Χρήσης, χωρίς κανένα
        περιορισμό.
      </p>

      <h1>12. ΕΠΕΞΕΡΓΑΣΙΑ ΔΕΔΟΜΕΝΩΝ</h1>
      <p className="fs-4">
        Κατά την χρήση των Υπηρεσιών, η Εταιρεία συλλέγει και χρησιμοποιεί
        συγκεκριμένα προσωπικά δεδομένα σχετικά με τον Τελικό Χρήστη και για
        εμπορικούς σκοπούς. Η χρήση των προσωπικών δεδομένων που συλλέγονται από
        την Εταιρεία γίνεται σύμφωνα με τον τρόπο που περιγράφεται στην Πολιτική
        Απορρήτου της, αντίγραφο της οποίας αναρτάται στην ιστοσελίδα της
        Εταιρείας, καθώς και σε απόλυτη συμφωνία με την νομοθεσία περί
        προστασίας Προσωπικών Δεδομένων (Γενικός Κανονισμός για την Προστασία
        Προσωπικών Δεδομένων (ΕΕ) 2016/679 (GDPR)), ως εκάστοτε ισχύει.
      </p>
      <p className="fs-4">
        Ο Τελικός Χρήστης δηλώνει ρητά και ανεπιφύλακτα ότι με την χρήση των
        Υπηρεσιών της Εταιρείας, συναινεί με την προαναφερθείσα επεξεργασία. Σε
        κάθε περίπτωση, ο Τελικός Χρήστης διατηρεί το δικαίωμα εναντίωσης σε
        αυτήν την επεξεργασία, αποστέλλοντας μήνυμα ηλεκτρονικού ταχυδρομείου
        στη διεύθυνση support@psmsgreece.gr
      </p>

      <h1>13. ΛΟΙΠΟΙ ΟΡΟΙ</h1>
      <p className="fs-4">
        <strong>Αυτοτέλεια όρου.</strong> Σε περίπτωση που κάποια από τις
        διατάξεις των όρων κριθεί άκυρη, ανίσχυρη ή μη εφαρμόσιμη, δεν
        επηρεάζεται το κύρος των υπόλοιπων όρων και διατάξεων, οι οποίοι
        εξακολουθούν να ισχύουν και τα παράγουν τα έννομα αποτελέσματα τους.
      </p>
      <p className="fs-4">
        <strong>Ανοχή.</strong> Η τυχόν μη ενάσκηση ή καθυστερημένη ενάσκηση κάποιου εκ των δικαιωμάτων της τεχνικής παρόχου εταιρείας στην Ελλάδα MOBILLY,, σε σχέση με την εφαρμογή των παρόντων Όρων και Προϋποθέσεων
        Χρήσης, δεν δύναται να προκαλέσει ζημία ή να επηρεάσει τα δικαιώματα της
        και τα δικαιώματα αποζημίωσης, ούτε δύναται να θεωρηθεί ως παραίτηση από
        τα υφιστάμενα δικαιώματα της ή παραίτηση από τα δικαιώματα της σε
        περίπτωση μελλοντικής παραβίασης.
      </p>
      <p className="fs-4">
        <strong>Αγγλική Γλώσσα.</strong> Σε περίπτωση διάστασης μεταξύ του
        Αγγλικού και του Ελληνικού κειμένου των Όρων, θα υπερισχύει το Αγγλικό
        κείμενο.
      </p>

      <h1>14. ΕΦΑΡΜΟΣΤΕΟ ΔΙΚΑΙΟ-ΔΙΚΑΙΟΔΟΣΙΑ</h1>
      <p className="fs-4">
        Οι Όροι θα διέπονται από το Ελληνικό Δίκαιο και οποιαδήποτε διαφορά
        ανακύψει σχετικά με την ερμηνεία και/ή την εφαρμογή και/ή την καταγγελία
        τους θα παραπέμπεται στα Δικαστήρια των Αθηνών, τα οποία θα αποφασίζουν
        επ' αυτής έχοντας αποκλειστική αρμοδιότητα.
      </p>
    </>
  );
}
